/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalDiagnosisPoiStatus
 */
export interface TerminalDiagnosisPoiStatus {
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisPoiStatus
     */
    globalStatus: string;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisPoiStatus
     */
    cardReaderOk?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisPoiStatus
     */
    communicationOk?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisPoiStatus
     */
    fraudPrevention?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisPoiStatus
     */
    pedOk?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisPoiStatus
     */
    printerStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisPoiStatus
     */
    securityOk?: boolean | null;
}

/**
 * Check if a given object implements the TerminalDiagnosisPoiStatus interface.
 */
export function instanceOfTerminalDiagnosisPoiStatus(value: object): value is TerminalDiagnosisPoiStatus {
    if (!('globalStatus' in value) || value['globalStatus'] === undefined) return false;
    return true;
}

export function TerminalDiagnosisPoiStatusFromJSON(json: any): TerminalDiagnosisPoiStatus {
    return TerminalDiagnosisPoiStatusFromJSONTyped(json, false);
}

export function TerminalDiagnosisPoiStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDiagnosisPoiStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'globalStatus': json['globalStatus'],
        'cardReaderOk': json['cardReaderOk'] === undefined ? undefined : json['cardReaderOk'] === null ? null : json['cardReaderOk'],
        'communicationOk': json['communicationOk'] === undefined ? undefined : json['communicationOk'] === null ? null : json['communicationOk'],
        'fraudPrevention': json['fraudPrevention'] === undefined ? undefined : json['fraudPrevention'] === null ? null : json['fraudPrevention'],
        'pedOk': json['pedOk'] === undefined ? undefined : json['pedOk'] === null ? null : json['pedOk'],
        'printerStatus': json['printerStatus'] === undefined ? undefined : json['printerStatus'] === null ? null : json['printerStatus'],
        'securityOk': json['securityOk'] === undefined ? undefined : json['securityOk'] === null ? null : json['securityOk'],
    };
}

export function TerminalDiagnosisPoiStatusToJSON(json: any): TerminalDiagnosisPoiStatus {
    return TerminalDiagnosisPoiStatusToJSONTyped(json, false);
}

export function TerminalDiagnosisPoiStatusToJSONTyped(value?: TerminalDiagnosisPoiStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'globalStatus': value['globalStatus'],
        'cardReaderOk': value['cardReaderOk'],
        'communicationOk': value['communicationOk'],
        'fraudPrevention': value['fraudPrevention'],
        'pedOk': value['pedOk'],
        'printerStatus': value['printerStatus'],
        'securityOk': value['securityOk'],
    };
}

